<template>
  <v-dialog
    v-model="dialog"
    :width="'900'"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
    height="100%"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" small class="primary d-print-none">
        <v-icon small left>
          mdi-trophy
        </v-icon>
        {{ $t("createNewEvent.createEvent") }}
      </v-btn>
    </template>
    <v-card height="100%">
      <v-toolbar
        flat
        tile
        class="flex-grow-0"
        :style="$vuetify.theme.dark ? '' : 'border-bottom: 0.5px solid #ccc;'"
      >
        <v-toolbar-title class="title">
          {{
            creatingNewLeague
              ? $t("createNewEvent.leagueCreationTitle")
              : $t("createNewEvent.eventCreationTitle")
          }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <NewLeague
        v-show="creatingNewLeague"
        :sports="sports"
        :creatingNewLeague="creatingNewLeague"
        :currentSport="currentSport"
        @cancelNewLeagueCreation="creatingNewLeague = false"
        @addCreatedLeague="addCreatedLeague"
      />

      <NewEvent
        ref="stepper"
        v-show="creatingNewLeague === false"
        :sports="sports"
        :fetchingSports="fetchingSports"
        :dialog="dialog"
        @closeDialog="dialog = false"
        @createNewLeague="createNewLeague"
        @fetchCreatedEvents="fetchCreatedEvents"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import NewEvent from "./NewEvent";
import NewLeague from "./NewLeague";

export default {
  data: () => ({
    dialog: false,
    creatingNewLeague: false,
    sports: [],
    fetchingSports: false,
    currentSport: "",
  }),

  components: { NewEvent, NewLeague },

  computed: {},

  created() {
    if (this.dialog) {
      this.fetchSports();
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        this.fetchSports();
      } else {
        this.creatingNewLeague = false;
      }
    },
  },

  methods: {
    fetchCreatedEvents() {
      this.$emit("fetchCreatedEvents");
    },
    addCreatedLeague({ league, sport }) {
      this.$refs.stepper.setLeague({ league, sport });
    },
    createNewLeague({ sport }) {
      this.creatingNewLeague = true;
      this.currentSport = sport;
    },
    fetchSports() {
      if (this.fetchingSports) {
        return;
      }

      this.fetchingSports = true;

      this.$axios
        .get(`/${this.$prefix()}/manualEvents/sports/listSports`)
        .then((res) => {
          this.sports = res.data.dados;
        })
        .finally(() => {
          this.fetchingSports = false;
        });
    },
  },
};
</script>
